import React from 'react';
import TrashIcon from '@assets/icons/trash.svg';
import { Animated, Dimensions, StyleProp, View, ViewStyle } from 'react-native';
import { createStyles } from '@/contexts/theme-context';
import { SCREEN_PADDING } from '@/styles';

// createAnimatedComponent needs a class component
class TrashClass extends React.Component<{
  containerStyle: StyleProp<ViewStyle>;
  iconColor: string;
}> {
  render() {
    return (
      <View style={this.props.containerStyle}>
        <TrashIcon fill={this.props.iconColor} />
      </View>
    );
  }
}
const AnimatedIcon = Animated.createAnimatedComponent(TrashClass);

interface Props {
  drag: Animated.Value | Animated.AnimatedInterpolation<number>;
  progress: Animated.Value | Animated.AnimatedInterpolation<number>;
}

export const DeleteActionView: React.FC<Props> = ({ drag, progress }) => {
  const [styles, theme] = useStyles();

  const backgroundTransition = progress.interpolate({
    inputRange: [0, 1],
    outputRange: [Dimensions.get('screen').width, 0],
  });
  const buttonTransition = progress.interpolate({
    inputRange: [0, 1, 2],
    outputRange: [0, 0, Dimensions.get('screen').width],
  });
  const scale = drag.interpolate({
    extrapolate: 'clamp',
    inputRange: [-80, 0],
    outputRange: [1, 0],
  });

  return (
    <Animated.View
      style={[
        styles.deleteAction,
        {
          transform: [{ translateX: backgroundTransition }],
        },
      ]}
      testID="delete-row"
    >
      <AnimatedIcon
        containerStyle={styles.trashIcon}
        iconColor={theme.colors.white}
        // @ts-ignore https://github.com/DefinitelyTyped/DefinitelyTyped/issues/43737
        style={{
          transform: [{ scale, translateX: buttonTransition }],
        }}
      />
    </Animated.View>
  );
};

const useStyles = createStyles((theme) => ({
  deleteAction: {
    alignItems: 'center',
    backgroundColor: theme.colors.negative,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: Dimensions.get('screen').width,
  },
  trashIcon: {
    left: SCREEN_PADDING,
    position: 'absolute',
  },
}));
